navHandler = {
  $header     : $('header'),
  $topBanner  : $('header .banner-container'),
  $pageIndex  : $('.page-template-page-index'),

  adjustMainTop: function() {
    $('main').css('margin-top',$('header').outerHeight());
  },

  toggleTopBanner: function() {
    //if (this.$pageIndex.length == 0) {
      // autohide "back to main site"
      var bannerHeight = this.$topBanner.outerHeight();
      if ($window.scrollTop() > bannerHeight) {
        this.$topBanner.css('margin-top',-bannerHeight);
      } else {
        this.$topBanner.css('margin-top',0);
      }
    //}
  },

  init: function(){
    var self = this;
    if (this.$topBanner.length > 0) {
      /* $window.on("resize", function() {
        setTimeout(function() {
          self.adjustMainTop();
        },50);
      }).trigger("resize"); */
      /* $window.on("scroll", function() {
        self.toggleTopBanner();
      });  */   
    }
  }
}